import { useLocation } from "react-router-dom";
import Seo from "./Seo";
import {
  DEFAULT_DESC,
  DEFAULT_KEYWORDS,
  DEFAULT_TITLE,
} from "../../utils/seoDefaults";
import { buildPrivateMuseTitle } from "../../utils/seoTitle";

export default function RouteSeo() {
  const location = useLocation();
  const path = location.pathname || "/";
  const normalizedPath =
    path !== "/" && path.endsWith("/") ? path.slice(0, -1) : path;
  const ownSeoExact = new Set([
    "/",
    "/home",
    "/HomePage",
    "/como-funciona",
    "/mapa-do-site",
    "/termos-de-uso-e-politica-de-privacidade",
    "/contato",
  ]);
  const ownSeoPrefixes = [
    "/acompanhantes-virtuais",
    "/indicacao",
    "/blog",
    "/contos-eroticos",
    "/mapa-do-site",
  ];
  const hasOwnSeo =
    ownSeoExact.has(normalizedPath) ||
    ownSeoPrefixes.some(
      (prefix) =>
        normalizedPath === prefix ||
        normalizedPath.startsWith(`${prefix}/`)
    );
  if (hasOwnSeo) return null;
  const params = new URLSearchParams(location.search);
  let title = DEFAULT_TITLE;
  let description = DEFAULT_DESC;
  let keywords = DEFAULT_KEYWORDS;

  if (path === "/" || path === "") {
    title = DEFAULT_TITLE;
    description = DEFAULT_DESC;
  } else if (path.startsWith("/acompanhantes-")) {
    const cat = (params.get("categoria") || "mulheres").toLowerCase();
    const label = cat === "homens" ? "Homens" : cat === "trans" ? "Trans" : "Mulheres";
    title = `Acompanhantes virtuais ${label} | Videochamada, chat privado e voz - Private Muse`;
    description = `Explore acompanhantes virtuais ${label.toLowerCase()} para videochamada, chat privado, chamada de voz e conteudo personalizado. Atendimento 100% online e perfis verificados na Private Muse.`;
    keywords = `${DEFAULT_KEYWORDS}, acompanhantes virtuais ${label.toLowerCase()}, acompanhantes online ${label.toLowerCase()}, videochamada ${label.toLowerCase()}, chat privado ${label.toLowerCase()}`;
  } else if (path.startsWith("/favoritos")) {
    title = "Seus Favoritos - Private Muse";
    description = "Gerencie e acesse rapidamente os perfis que voce salvou na Private Muse.";
  } else if (path.startsWith("/perfilCliente")) {
    title = "Seu Perfil - Private Muse";
    description = "Veja e edite seu perfil de cliente na Private Muse.";
  } else if (path.startsWith("/cliente/profile-setup")) {
    title = "Complete seu cadastro - Private Muse";
    description = "Preencha suas informacoes basicas para continuar na Private Muse.";
  } else if (
    path.startsWith("/perfilMusa") ||
    path.startsWith("/musa/profile") ||
    path.startsWith("/musa/")
  ) {
    title = "Perfil da Musa - Private Muse";
    description = "Veja detalhes de perfis, fotos e avaliacoes na Private Muse.";
  } else if (path.startsWith("/pagamentos")) {
    title = "Planos - Private Muse";
    description = "Conheca os planos para acompanhantes e destaque seu perfil na Private Muse.";
  } else if (path.startsWith("/login")) {
    title = "Entrar - Private Muse";
    description = "Entre na Private Muse para acessar todos os recursos e perfis.";
  } else if (path === "/cadastro" || path === "/cadastro/") {
    title = "Cadastro na Private Muse | Crie sua conta com mais seguranca";
    description =
      "Crie sua conta na Private Muse para acessar perfis verificados, salvar favoritos e navegar por acompanhantes virtuais, videochamada, chat privado e chamada de voz com mais clareza.";
  } else if (
    normalizedPath === "/cadastro-acompanhante"
  ) {
    title = buildPrivateMuseTitle("Cadastro de acompanhante virtual");
    description =
      "Abra seu cadastro de acompanhante virtual na Private Muse, conheca as etapas da verificacao e publique seu perfil para atendimento 100% online com mais clareza e seguranca.";
  } else if (path.startsWith("/cadastro")) {
    title = "Continue seu cadastro - Private Muse";
    description =
      "Avance no fluxo de cadastro da Private Muse para concluir sua conta com verificacao e mais seguranca.";
  } else if (path.startsWith("/stories")) {
    title = "Stories - Private Muse";
    description = "Veja stories e atualizacoes das musas na Private Muse.";
  } else if (path.startsWith("/denuncias")) {
    title = "Denuncias - Private Muse";
    description = "Envie denuncias e ajude a manter a comunidade segura na Private Muse.";
  } else if (path.startsWith("/contato")) {
    title = "Contato - Private Muse | Acompanhantes Virtuais";
    description =
      "Entre em contato com a Private Muse. Tire duvidas sobre nosso servico de acompanhantes virtuais com atendimento discreto e profissional.";
  } else if (path.startsWith("/como-funciona")) {
    title = "Como Funciona - Atendimento Virtual | Private Muse";
    description =
      "Entenda como funciona o atendimento virtual da Private Muse. Atendimento 100% online, discreto e seguro.";
  }

  return (
    <Seo title={title} description={description} keywords={keywords} />
  );
}
